export const REFRESH_TOKEN_MINUTES = process.env.REACT_APP_REFRESH_TOKEN_MINUTES;
export const LOGIN_EXPIRE_DAYS = process.env.REACT_APP_LOGIN_EXPIRE_DAYS;
export const SHOW_GLOBAL_BAR = process.env.REACT_APP_SHOW_GLOBAL_BAR;
